// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"cd75c76d","222":"04454109","771":"f06a9bc7","880":"3cfc8bd3"}[chunkId] + ".chunk.js";
};